import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/service/auth.service';
import { NgxSpinnerService } from "ngx-spinner";
import swal from "sweetalert2";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
  
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  submitted = false;
  isError = '';
  isCode: Boolean;
  private loginSubs: Subscription;
  constructor(private formBuilder: FormBuilder, private authService: AuthService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.isCode = true;
    this.spinner.hide();
    this.loginSubs = this.authService.getAuthStatusListner().subscribe((response) => {
      this.spinner.hide();
      this.isError = this.authService.getError();
      this.isError != '' && this.msgPopup(this.isError, 'error');
    });
    this.loginForm = this.formBuilder.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.spinner.show();
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.spinner.hide();
      return;
    }

    this.authService.login(this.loginForm.value.userName, this.loginForm.value.password);
  }

  msgPopup(title, icon) {
    swal.fire({
      icon: icon,
      title: title,
      showConfirmButton: false,
      timer: 1500
    });
  }

  ngOnDestroy() {
    // this.loginSubs.unsubscribe();
  }
}